<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Włączanie usługi'" class="mb-0" />
            <h5 v-text="'Informacja'" class="text-danger text-center mb-0" />
        </template>

        <div class="p-3">
            <p class="text-center">
                <a-icon
                    class="text-warning"
                    width="40px"
                    height="40px"
                    icon="WarningFull"
                />
            </p>
            <p class="text-primary">
                <span v-text="'Uwaga!'" class='text-danger' />
                Posiadasz konto na Kaucyjni.pl pod tym samym loginem co w EuroPlatform.
                <br />
                <br />
                Aby system kaucyjny poprawnie działał w Twoich sklepach z EuroPlatform,
                w następnym kroku poprosimy Cię o weryfkację zgodności danych sklepów w obu systemach.
                <br />
                <br />
                Połączenie sklepów spowoduje:
                <ul>
                    <li v-text="'nadpisanie danych adresowych w Kaucyjni.pl'" />
                    <li v-text="'aktualizację pakietu w Kaucyjni.pl na Specjalny EC'" />
                    <li
                        v-text="`możliwość harmonijnego korzystania z obu systemów
                        (dane dla powiązanych sklepów będą na bieżąco aktualizowane)`"
                    />
                </ul>
            </p>

            <p class="text-center py-3">
                <img :src="require('@/assets/img/drs/location-mapping.svg')" class="mw-100" />
            </p>

            <ui-checkbox-input
                v-model="isConfirmed"
                class="text-primary text-sm"
                name="intro-confirm"
                :label="`
                    Potwierdzam, że zapoznałem/am się z powyższą informacją i mam świadomość, że muszę dokonać
                    powiązania sklepów, aby system kaucyjny działał poprawnie<span class='text-danger'>*</span>
                `"
            />
        </div>
        <template #footer>
            <the-btn
                text="Wróć"
                class="btn-outline-custom"
                @click="goBack"
            />
            <the-btn
                text="Przejdź do powiązania sklepów"
                class="btn-secondary"
                :disabled="!isConfirmed"
                @click="goToLocationMapping"
            />
        </template>
    </ui-modal>
</template>

<script>
import locationMappingMixin from '@/components/drs/service/location-mapping.mixin'

export default {
    mixins: [locationMappingMixin],

    provide() {
        return {
            closeModal: this.closeModalAndClearState
        }
    },

    data: () => ({
        isConfirmed: false
    }),

    methods: {
        goToLocationMapping() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/service/LocationMapping'
            })
        },
        goBack() {
            this.clearLocationMappingFlow()

            this.$store.dispatch('openModal', {
                component: 'AcceptService'
            })
        }
    }
}
</script>